import { useAuth } from "@/lib/contexts/auth.context";
import { Navigate } from "react-router-dom";

/**
 * When the user navigates to this component, this component will redirect
 * them to the dashboard if they are authenticated. Otherwise, it will redirect
 * them to the login page.
 *
 * This component is used to handle the root path of the application.
 *
 * @returns
 */
export function RootRedirect() {
	const { isAuthenticated } = useAuth();
	console.log("root redirect", isAuthenticated);

	if (isAuthenticated) {
		return <Navigate to="/dashboard" replace />;
	}

	return <Navigate to="/auth/login" replace />;
}
